import React, { useEffect, useState } from 'react';

import { Button } from '@material-ui/core';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { caseColors, caseStatuses, mapOrderField } from '../../models/Case';
import TableDense from '../common/TableDense';

const creatorDashboardColumns = [
  {
    label: 'Request Date',
    name: 'createdAt',
    render: (value) => {
      if (!value || !moment(value).isValid()) return <span>-</span>;

      const formattedDate = moment(value).format('MM/DD/YYYY');
      return <span>{formattedDate}</span>;
    },
  },
  {
    label: 'Patient',
    name: 'patient',
    render: (value, data) => {
      return <span>{data.patient?.name || '-'}</span>;
    },
  },
  {
    label: 'Date Paid',
    name: 'datePaid',
    render: (value, data) => {
      if (!data?.userReport?.createdAt || !moment(data?.userReport?.createdAt).isValid()) return <span>Unpaid</span>;

      const formattedDate = moment(data?.userReport?.createdAt).format('MM/DD/YYYY');
      return <span>{formattedDate}</span>;
    },
  },
  {
    label: 'Status',
    name: 'status',
    render: (value, data) => {
      if (!data?.status?.value) return <span>-</span>;
      return <span style={{ color: caseColors[data.status.value] }}>{data?.status?.label}</span>;
    },
  },
  {
    label: 'Video Report',
    name: 'videoReport',
    render: (value, data) => {
      if (data.status.value !== caseStatuses.completed.value) {
        return (
          <Button disabled size="small" variant="contained" disableElevation>
            Video Report
          </Button>
        );
      }

      return (
        <Link to={`/case-details?caseId=${data.id}`} style={{ textDecoration: 'none' }}>
          <Button variant="contained" disableElevation color="primary" size="small">
            Video Report
          </Button>
        </Link>
      );
    },
  },
];

export default ({ cases, total, onCriteriaChange, page }) => {
  const [columns] = useState(creatorDashboardColumns);

  const defaultOptions = {
    count: total,
    onRowSelectionChange: () => {
      // console.log(currentRowsSelected);
      // const { id } = cases[currentRowsSelected.index];
      // onCaseClick(id);
    },
    onTableChange: (action, tableState) => {
      const criteria = {};
      switch (action) {
        case 'sort':
          criteria.orderType = tableState.sortOrder.direction.toUpperCase();
          criteria.orderField = mapOrderField(tableState.sortOrder.name);
          break;
        case 'changePage':
          criteria.page = tableState.page;
          break;
        case 'changeRowsPerPage':
          criteria.limit = tableState.rowsPerPage;
          setTableOptions({
            ...tableOptions,
            rowsPerPage: tableState.rowsPerPage,
          });
          break;
        default:
          return;
      }
      onCriteriaChange(criteria);
    },
    serverSide: true,
  };

  const [tableOptions, setTableOptions] = useState(defaultOptions);

  useEffect(() => {
    setTableOptions({
      ...tableOptions,
      count: total,
      onRowSelectionChange: () => {
        // const caseStudy = cases[currentRowsSelected.index];
        // onCaseClick(caseStudy);
      },
      page,
    });
  }, [total, cases, page, tableOptions]);

  return <TableDense tableId="case-list" className="small-padding-table" columns={columns} data={cases || []} options={tableOptions} />;
};
